import { SchemaDeSerBuilder } from "./deser"
import { JsonBuilder, type JsonMap } from "./util/json"

class PreferencesAccount {
  currentAccount = ""
  privacy = false
}

export class RecentSymbolSearchResult {
  symbol: string | null = null
  description: string | null = null
  listedMarket: string | null = null
  hasOptions = false
  etf = false
  instrumentType: string | null = null
  eventProductExternalId: string | null = null
  externalId: string | null = null
  category: string | null = null
}

const DEFAULT_RECENT_SYMBOLS = ["SPY", "QQQ", "IWM", "DIA", "TLT"]

export function createDefaultRecentSymbolSearchResults(): RecentSymbolSearchResult[] {
  return DEFAULT_RECENT_SYMBOLS.map((symbol) => {
    const result = new RecentSymbolSearchResult()

    result.symbol = symbol
    result.description = symbol
    result.hasOptions = true
    result.etf = true

    return result
  })
}

export class CommonAppsPreferences {
  recentSymbolSearchResultsV2: RecentSymbolSearchResult[] =
    createDefaultRecentSymbolSearchResults()
}

export class Preferences {
  account = new PreferencesAccount()
  commonApps = new CommonAppsPreferences()
}

const PREFERENCES_ACCOUNT_DESER = new SchemaDeSerBuilder(PreferencesAccount)
  .ofString("currentAccount")
  .ofBoolean("privacy")
  .toDeSer()

const RECENT_SYMBOL_SEARCH_RESULT_DESER = new SchemaDeSerBuilder(
  RecentSymbolSearchResult
)
  .ofNullableString("symbol")
  .ofNullableString("description")
  .ofNullableString("listedMarket")
  .ofBoolean("hasOptions", "options")
  .ofBoolean("etf")
  .ofNullableString("instrumentType")
  .ofNullableString("eventProductExternalId")
  .ofNullableString("externalId")
  .ofNullableString("category")
  .toDeSer()

const COMMON_APPS_PREFERENCES_DESER = new SchemaDeSerBuilder(
  CommonAppsPreferences
)
  .ofArray(
    "recentSymbolSearchResultsV2",
    RECENT_SYMBOL_SEARCH_RESULT_DESER,
    RecentSymbolSearchResult
  )
  .toDeSer()

export const PREFERENCES_DESER = new SchemaDeSerBuilder(Preferences)
  .ofNested("account", PREFERENCES_ACCOUNT_DESER, PreferencesAccount)
  .ofNested("commonApps", COMMON_APPS_PREFERENCES_DESER, CommonAppsPreferences)
  .toDeSer()

export interface CommonAppsPatch extends JsonMap {
  "common-apps": {
    "recent-symbol-search-results-v2": JsonMap[]
  }
}

export function toCommonAppsPatch(
  recentSymbolSearchResults: RecentSymbolSearchResult[]
): CommonAppsPatch {
  const commonApps = new CommonAppsPreferences()
  commonApps.recentSymbolSearchResultsV2 = recentSymbolSearchResults

  const builder = new JsonBuilder()
  COMMON_APPS_PREFERENCES_DESER.serialize(commonApps, builder)

  return { "common-apps": builder.json } as CommonAppsPatch
}
